export const categories = [
  {
    slug: "movie",
    name: "电影",
    icon: "ri-film-line",
    description: "院线大片、经典佳片，随时随地畅享影院级观影体验"
  },
  {
    slug: "tv",
    name: "电视剧",
    icon: "ri-tv-line",
    description: "热门国产剧、海外剧集，追剧不等待"
  },
  {
    slug: "variety",
    name: "综艺",
    icon: "ri-music-line",
    description: "搞笑综艺、真人秀、脱口秀，欢乐不断"
  },
  {
    slug: "anime",
    name: "动漫",
    icon: "ri-ghost-line",
    description: "日漫国漫、经典番剧，二次元世界尽在掌握"
  },
  {
    slug: "documentary",
    name: "纪录片",
    icon: "ri-earth-line",
    description: "自然探索、人文历史，足不出户看世界"
  },
  {
    slug: "kids",
    name: "少儿",
    icon: "ri-emotion-happy-line",
    description: "益智动画、亲子内容，陪伴孩子快乐成长"
  }
];

export const movies = [
  {
    id: 1,
    title: "流浪地球3",
    category: "movie",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20style%2C%20epic%20space%20adventure%20with%20astronaut%20and%20Earth%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20background%20with%20neon%20accents%2C%20movie%20poster%20design%2C%20high%20quality%20digital%20art&width=600&height=800&seq=movie-cover-01&orientation=portrait",
    rating: 8.5,
    year: 2026,
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的旅程，人类的勇气和智慧将面临终极考验。",
    tags: ["科幻", "冒险", "国产"],
    hot: true,
    isNew: true
  },
  {
    id: 2,
    title: "封神第二部",
    category: "movie",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20poster%2C%20ancient%20Chinese%20warriors%20in%20epic%20battle%2C%20golden%20and%20red%20color%20scheme%2C%20dramatic%20cinematic%20lighting%2C%20mythical%20creatures%2C%20movie%20poster%20design%20style&width=600&height=800&seq=movie-cover-02&orientation=portrait",
    rating: 8.8,
    year: 2025,
    description: "商朝末年，纣王暴虐无道。姜子牙携封神榜下山，辅佐周武王起兵伐纣。一场神魔大战即将拉开帷幕。",
    tags: ["神话", "奇幻", "国产"],
    hot: true,
    isNew: false
  },
  {
    id: 3,
    title: "长安三万里2",
    category: "anime",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%2C%20ancient%20Tang%20Dynasty%20Changan%20city%20landscape%2C%20poetic%20Chinese%20ink%20painting%20style%2C%20warm%20golden%20tones%2C%20beautiful%20illustration%2C%20artistic%20composition&width=600&height=800&seq=movie-cover-03&orientation=portrait",
    rating: 9.0,
    year: 2026,
    description: "安史之乱后，高适被困孤城，回首与李白的一生情谊。那些盛唐的诗篇，那些壮志凌云的岁月，在记忆中熠熠生辉。",
    tags: ["动画", "历史", "国产"],
    hot: true,
    isNew: true
  },
  {
    id: 4,
    title: "庆余年第三季",
    category: "tv",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%2C%20handsome%20male%20lead%20in%20ancient%20Chinese%20costume%2C%20dramatic%20lighting%2C%20royal%20palace%20background%2C%20cinematic%20composition%2C%20rich%20color%20palette&width=600&height=800&seq=movie-cover-04&orientation=portrait",
    rating: 9.2,
    year: 2026,
    description: "范闲在庆国朝堂之上步步为营，揭开身世之谜的同时，也卷入了更大的权力漩涡之中。",
    tags: ["古装", "权谋", "国产剧"],
    hot: true,
    isNew: true
  },
  {
    id: 5,
    title: "鬼灭之刃 无限城篇",
    category: "anime",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20movie%20poster%20style%2C%20demon%20slayer%20warrior%20with%20sword%2C%20dynamic%20action%20pose%2C%20dark%20fantasy%20atmosphere%2C%20vibrant%20fire%20effects%2C%20cinematic%20lighting%2C%20high%20quality%20illustration&width=600&height=800&seq=movie-cover-05&orientation=portrait",
    rating: 9.4,
    year: 2025,
    description: "炭治郎一行人闯入无限城，面对上弦之鬼的终极挑战。最终的决战，即将在这里打响。",
    tags: ["热血", "战斗", "日漫"],
    hot: true,
    isNew: false
  },
  {
    id: 6,
    title: "奔跑吧第14季",
    category: "variety",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20group%20of%20celebrities%20running%20and%20laughing%2C%20bright%20colorful%20design%2C%20energetic%20atmosphere%2C%20outdoor%20adventure%20theme%2C%20fun%20and%20playful%20composition&width=600&height=800&seq=movie-cover-06&orientation=portrait",
    rating: 7.8,
    year: 2026,
    description: "跑男团再次集结！全新一季带来更多欢笑与挑战，明星嘉宾们将在各种趣味游戏中展开激烈角逐。",
    tags: ["真人秀", "搞笑", "户外"],
    hot: false,
    isNew: true
  },
  {
    id: 7,
    title: "地球脉动第四季",
    category: "documentary",
    cover: "https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%2C%20stunning%20wildlife%20photography%2C%20polar%20bear%20in%20arctic%20landscape%2C%20epic%20natural%20scenery%2C%20cinematic%20composition%2C%20professional%20wildlife%20photography%20style&width=600&height=800&seq=movie-cover-07&orientation=portrait",
    rating: 9.8,
    year: 2026,
    description: "BBC经典纪录片系列全新回归，带你深入地球最偏远的角落，见证自然界最震撼的生命奇迹。",
    tags: ["自然", "BBC", "精品"],
    hot: false,
    isNew: true
  },
  {
    id: 8,
    title: "熊出没·重启未来",
    category: "kids",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20animated%20kids%20movie%20poster%2C%20cute%20bear%20characters%20in%20futuristic%20setting%2C%20bright%20colorful%20style%2C%20friendly%20and%20fun%20atmosphere%2C%20childrens%20animation%20design&width=600&height=800&seq=movie-cover-08&orientation=portrait",
    rating: 8.2,
    year: 2026,
    description: "熊大熊二和光头强意外穿越到未来世界，展开一场充满想象力的奇妙冒险之旅。",
    tags: ["动画", "冒险", "亲子"],
    hot: false,
    isNew: true
  },
  {
    id: 9,
    title: "大奉打更人",
    category: "tv",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20detective%20drama%20poster%2C%20male%20lead%20in%20ancient%20official%20uniform%2C%20mysterious%20night%20scene%2C%20lantern%20lights%2C%20intrigue%20atmosphere%2C%20cinematic%20composition&width=600&height=800&seq=movie-cover-09&orientation=portrait",
    rating: 8.6,
    year: 2025,
    description: "现代打工人许七安穿越到大奉王朝，凭借现代知识和过人智慧，在这片神秘大陆上步步为营。",
    tags: ["古装", "探案", "喜剧"],
    hot: true,
    isNew: false
  },
  {
    id: 10,
    title: "哪吒之魔童闹海",
    category: "anime",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%2C%20mythological%20character%20with%20flaming%20wheels%20and%20red%20ribbon%2C%20epic%20sea%20battle%20scene%2C%20dramatic%20lighting%2C%20vibrant%20red%20and%20gold%20colors%2C%20cinematic&width=600&height=800&seq=movie-cover-10&orientation=portrait",
    rating: 9.1,
    year: 2025,
    description: "天劫之后，哪吒和敖丙的灵魂虽保住了，但肉身即将魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身。",
    tags: ["动画", "神话", "国产"],
    hot: true,
    isNew: false
  },
  {
    id: 11,
    title: "奥本海默",
    category: "movie",
    cover: "https://readdy.ai/api/search-image?query=Biographical%20thriller%20movie%20poster%2C%20man%20in%20fedora%20hat%20against%20mushroom%20cloud%20explosion%2C%20black%20and%20white%20with%20orange%20fire%2C%20dramatic%20cinematic%20style%2C%20historical%20drama&width=600&height=800&seq=movie-cover-11&orientation=portrait",
    rating: 8.9,
    year: 2023,
    description: "聚焦美国'原子弹之父'罗伯特·奥本海默，讲述他在曼哈顿计划中研制原子弹的传奇经历与内心挣扎。",
    tags: ["传记", "历史", "剧情"],
    hot: false,
    isNew: false
  },
  {
    id: 12,
    title: "鱿鱼游戏第二季",
    category: "tv",
    cover: "https://readdy.ai/api/search-image?query=Korean%20thriller%20drama%20poster%2C%20mysterious%20masked%20figures%20in%20colorful%20playground%20setting%2C%20dark%20atmosphere%2C%20geometric%20patterns%2C%20suspenseful%20cinematic%20style&width=600&height=800&seq=movie-cover-12&orientation=portrait",
    rating: 8.3,
    year: 2025,
    description: "成奇勋放弃去美国的计划，带着新的目的重新回到游戏中。这一次，他要揭开游戏背后的真相。",
    tags: ["韩剧", "悬疑", "惊悚"],
    hot: true,
    isNew: false
  },
  {
    id: 13,
    title: "王牌对王牌第9季",
    category: "variety",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20variety%20talk%20show%20poster%2C%20celebrities%20playing%20games%20on%20colorful%20stage%2C%20bright%20studio%20lighting%2C%20fun%20and%20energetic%20atmosphere%2C%20entertainment%20show%20design&width=600&height=800&seq=movie-cover-13&orientation=portrait",
    rating: 7.5,
    year: 2026,
    description: "经典IP对决再度升级！王牌家族携手飞行嘉宾，带来更多欢乐与感动。",
    tags: ["真人秀", "搞笑", "棚内"],
    hot: false,
    isNew: true
  },
  {
    id: 14,
    title: "蓝色星球第三季",
    category: "documentary",
    cover: "https://readdy.ai/api/search-image?query=Ocean%20documentary%20poster%2C%20stunning%20underwater%20photography%2C%20colorful%20coral%20reef%20with%20diverse%20marine%20life%2C%20crystal%20clear%20blue%20water%2C%20cinematic%20nature%20photography%20style&width=600&height=800&seq=movie-cover-14&orientation=portrait",
    rating: 9.7,
    year: 2025,
    description: "深入全球最神秘的海洋深处，探索前所未见的海洋生物与生态系统。",
    tags: ["海洋", "BBC", "精品"],
    hot: false,
    isNew: false
  },
  {
    id: 15,
    title: "汪汪队立大功大电影3",
    category: "kids",
    cover: "https://readdy.ai/api/search-image?query=Childrens%20animated%20movie%20poster%2C%20cute%20puppy%20rescue%20team%20in%20action%2C%20bright%20sunny%20day%2C%20colorful%20vehicles%2C%20friendly%20characters%2C%20fun%20adventure%20theme%2C%20kids%20animation%20style&width=600&height=800&seq=movie-cover-15&orientation=portrait",
    rating: 8.0,
    year: 2026,
    description: "汪汪队再次出发！这次他们面对的是前所未有的挑战，需要所有成员的团结协作。",
    tags: ["动画", "冒险", "亲子"],
    hot: false,
    isNew: true
  },
  {
    id: 16,
    title: "沙丘3",
    category: "movie",
    cover: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%2C%20desert%20planet%20landscape%20with%20giant%20sandworms%2C%20futuristic%20still%20suits%2C%20golden%20sand%20dunes%2C%20cinematic%20composition%2C%20grand%20scale%2C%20atmospheric%20lighting&width=600&height=800&seq=movie-cover-16&orientation=portrait",
    rating: 8.7,
    year: 2026,
    description: "保罗·厄崔迪斯成为弗雷曼人的领袖后，踏上了宇宙级的复仇之路，整个银河系的命运悬于一线。",
    tags: ["科幻", "史诗", "冒险"],
    hot: false,
    isNew: true
  }
];